import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root',
})
export class FamilyTreeService {
  constructor(private readonly httpService: AmplifyHttpClient) {}

  getFamilyTrees() {
    const url = `api/network/family-tree`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createFamilyTree(payload) {
    const url = `api/network/family-tree`;
    return this.httpService.post(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateFamilyTree(payload) {
    const url = `api/network/family-tree`;
    return this.httpService.patch(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  deleteFamilyTree(familyTreeId) {
    const url = `api/network/family-tree/${familyTreeId}`;
    return this.httpService.delete(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  getFamilyTreeById(id) {
    const url = `api/network/family-tree/${id}`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  getFamilyTreeMembers(id, type?: string) {
    const url = type ? `api/network/family-tree-member/${id}/${type}` : `api/network/family-tree-member/${id}`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  createFamilyTreeMember(payload) {
    const url = `api/network/family-tree-member`;
    return this.httpService.post(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  updateFamilyTreeMember(payload) {
    const url = `api/network/family-tree-member`;
    return this.httpService.patch(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  deleteFamilyTreeMember(memberId) {
    const url = `api/network/family-tree-member/${memberId}`;
    return this.httpService.delete(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  getFamilyTreeRelationships(familyTreeId) {
    const url = `api/network/family-tree-relationship/${familyTreeId}`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  createFamilyTreeRelationship(payload) {
    const url = `api/network/family-tree-relationship`;
    return this.httpService.post(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  deleteFamilyTreeRelationship(relationshipId) {
    const url = `api/network/family-tree-relationship/${relationshipId}`;
    return this.httpService.delete(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  getFamilyTreeRelationshipSuggestions(familyTreeId, userId, relationshipType) {
    const url = `api/network/family-tree-relationship-suggestions/${familyTreeId}/${userId}/${relationshipType}`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }

  getFamilyTreeUserDetails(userId) {
    const url = `api/network/family-tree-user-details/${userId}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response.data;
        }
      })
    );
  }
}
